import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type"];
import { AbstractAlert } from './AbstractAlert';
import { jsx as _jsx } from "react/jsx-runtime";
export const Alert = _ref => {
  let {
      type = 'info'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AbstractAlert, Object.assign({
    type: type
  }, props));
};